import { IMainPromoPin } from '../../types/newbuilding/mainPromoPin';
import { IApplicationState } from '../../types/redux';

export function getMainPromoPin(state: IApplicationState): IMainPromoPin | null {
  return state.newbuilding.mainPromoPin;
}
